import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const FrontModalPanel: React.FC<Props> = ({ children, className = '' }) => (
  <div
    className={`ips-frontfw-overlay__panel ips-frontfw-overlay__panel--modal ${className}`.trim()}
    role="dialog"
    aria-modal="true"
  >
    {children}
  </div>
);
